export default {
  computed: {
    isWipLimitsOn() {
      return false;
    },
  },
};
